import { useMemo } from "react";
import { useTable } from "react-table";
import styled from "@emotion/styled";
import SkelentonLoader from "./Loaders/SkeletonTableLoader";
import NoData from "./NoData";
interface BasicTableProps {
  data: any[];
  columns: any;
  loading: boolean;
  selectedRow?: (rowValue: any) => void;
  startIndex?: number;
}

const BasicTable = (props: BasicTableProps) => {
  const { data: TData = [], columns: TColumn, loading, selectedRow, startIndex = 1 } = props;
  const columns = useMemo(() => TColumn, [TColumn]);
  const data = useMemo(() => TData, [TData]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  });
  const rowClicked = (rowValue: any) => {
    if (selectedRow != null) {
      selectedRow(rowValue.original);
    }
  };
  return (
    <BasicTable.Wrapper>
      <div className="tableWrap">
        <table className="vehicle-table-content" {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup, index) => (
              <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                <th>S/N</th>
                {headerGroup.headers.map((column, index) => (
                  <th key={index} {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          {loading ? (
            <tbody>
              <SkelentonLoader colSpan={columns.length} />
            </tbody>
          ) : (
            <tbody {...getTableBodyProps()}>
              {rows.map((row, index: number) => {
                prepareRow(row);
                return (
                  <tr
                    key={index}
                    {...row.getRowProps()}
                    onClick={() => {
                      rowClicked(row);
                    }}
                    className={`${selectedRow != null ? "cursor" : ""}`}
                  >
                    <td>{startIndex + index}</td>
                    {row.cells.map((cell) => {
                      return (
                        <td key={index} {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
        {!loading && data.length === 0 ? <NoData /> : <div />}
      </div>
    </BasicTable.Wrapper>
  );
};

BasicTable.Wrapper = styled.div`
  .tableWrap {
    overflow-y: auto; /* make the table scrollable if height is more than 200 px  */
    height: 500px; /* gives an initial height of 200px to the table */
  }
  .tableWrap thead th {
    position: sticky; /* make the table heads sticky */
    top: 0px; /* table head will be placed from the top of the table and sticks to it */
    z-index: 10;
  }
  table {
    border-collapse: collapse; /* make the table borders collapse to each other */
    width: 100%;
  }
  th,
  td {
    padding: 8px 16px;
    border: 1px solid #ccc;
  }
  th {
    background: #eee;
  }
`;

export default BasicTable;
